import { DeclarationType } from "constants/documentTypes";
import { Species } from "constants/species";

export const declarationVersions = {
  [Species.CATTLE]: [
    {
      value: DeclarationType.C0413,
      label: "Cattle (Yellow) C0413",
    },
    {
      value: DeclarationType.C0720,
      label: "Cattle (Yellow) C0720",
    },

    {
      value: DeclarationType.E0413,
      label: "EU Cattle (Green) E0413",
    },
    {
      value: DeclarationType.E0720,
      label: "EU Cattle (Green) E0720",
    },
    {
      value: DeclarationType.BC0720,
      label: "Bobby Calves (Dark Green) BC0720",
    },
  ],
  [Species.SHEEP]: [
    {
      value: DeclarationType.S0413,
      label: "Sheep (Purple) S0413",
    },
    {
      value: DeclarationType.S0720,
      label: "Sheep (Purple) S0720",
    },
    {
      value: DeclarationType.G0720,
      label: "Goat (Red) G0720",
    },
    {
      value: DeclarationType.G0524,
      label: "Goat (Red) G0524",
    },
    {
      value: DeclarationType.HG0324,
      label: "Harvested Rangeland Goats (Blue) HG0324",
    },
  ],
};
